import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function OrderLookupPage() {
  const { orderNumber } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .getOrder(orderNumber)
      .then(() => navigate(`/confirmation/${orderNumber}`, { replace: true }))
      .catch((e) => { console.error('Order lookup error:', e); setLoading(false); });
  }, [orderNumber, navigate]);

  if (loading) {
    return (
      <div className="container page-center">
        <div className="spinner" />
        <p>Looking up order...</p>
      </div>
    );
  }

  return (
    <div className="container page-center">
      <p className="error-text">Order "{orderNumber}" not found</p>
      <button className="btn btn-primary" onClick={() => navigate('/')}>
        Back to Menu
      </button>
    </div>
  );
}
